<ng-container *transloco="let t; prefix: scope">
  <div class="flex flex-col h-full">
    <p class="text-xl font-semibold">{{ t('usersTitle') }}</p>

    <ng-container *ngIf="!isLoading(); else loadingTemplate">
      <div class="flex justify-between h-full">
        <div>
          <app-user-avatar-with-extended-info containerClass="mb-2" [users]="admins" [maxVisibleUsers]="8">
          </app-user-avatar-with-extended-info>
          <app-user-avatar-with-extended-info [users]="users" [maxVisibleUsers]="8">
          </app-user-avatar-with-extended-info>
        </div>
        <div class="flex items-end">
          <bl-frontend-tooltip [heading]="!isCurrentUserClientResponsibleOrAdmin() ? t('missingPermissionToAddAdmin') : null">
            <bl-frontend-button
            variant="tonal"
            [text]="t('addAdmin')"
            (onclick)="openAddAdminDialog()"
            [disabled]="!isCurrentUserClientResponsibleOrAdmin()"
            [trailingIcon]="{ name: 'plus' }"></bl-frontend-button>
          </bl-frontend-tooltip>
        </div>
      </div>
    </ng-container>
  </div>

  <ng-template #loadingTemplate>
    <p class="animate-pulse h-8 bg-blg-grey-100 rounded w-3/4"></p>
    <p class="animate-pulse h-8 bg-blg-grey-100 rounded w-3/4"></p>
  </ng-template>
</ng-container>
